
import { Component, Prop, Vue } from "nuxt-property-decorator";
import { BIcon, BIconXLg } from "bootstrap-vue";
@Component({
  components: {
    BIcon,
    BIconXLg,
  },
})
export default class TheModalHeader extends Vue {
  @Prop() close!: any;
}
